import type { FC } from "react";

import { BasicModal, Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";

import { MODAL_CONFIGS } from "./config";
import {
    StyledDescription,
    StyledHeader,
    StyledButtonContainer,
    StyledReminderInner,
    StyledTitle,
    StyledExpandableWrap,
} from "./styles";

type ManagementSignalApiModalProps = {
    isOpened: boolean;
    onSubmit: VoidFunction;
    onCancel: VoidFunction;
};

const ManagementSignalApiModal: FC<ManagementSignalApiModalProps> = ({ isOpened, onSubmit, onCancel }) => {
    return (
        <BasicModal
            isOpen={isOpened}
            closeIconConfig={{
                show: false,
            }}
            customStyles={MODAL_CONFIGS}
            shouldCloseOnOverlayClick={false}
        >
            <StyledReminderInner onClick={(e) => e.stopPropagation()}>
                <StyledExpandableWrap>
                    <StyledHeader>
                        <I18n
                            element={StyledTitle}
                            data-automation="management-signal-api.title-text"
                            translatable={{ key: "si.management.signal-api.modal.title" }}
                        />
                    </StyledHeader>
                    <>
                        <I18n
                            element={StyledDescription}
                            data-automation="management-signal-api.description-text"
                            translatable={{
                                key: "si.management.signal-api.modal.description",
                            }}
                        />
                        <StyledButtonContainer>
                            <Button
                                type="flat"
                                onClick={onCancel}
                            >
                                {translate("si.common.button.cancel")}
                            </Button>
                            <Button
                                type="primary"
                                onClick={onSubmit}
                            >
                                {translate("common.button.quit")}
                            </Button>
                        </StyledButtonContainer>
                    </>
                </StyledExpandableWrap>
            </StyledReminderInner>
        </BasicModal>
    );
};

export default ManagementSignalApiModal;
